import { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getCities } from 'system-redux-sagas/actions';

type TUseCities = {
  cities: { id: string; label: string; state: string }[];
  loadingCities: boolean;
};

export const useCities = (fetch: boolean = true): TUseCities => {
  const lock = useRef<boolean>(false);
  const { cities, loadingCities } = useSelector((state: any) => state.system);
  const dispatch = useDispatch();

  useEffect(() => {
    if (!lock.current) {
      lock.current = true;
      fetch && dispatch(getCities());
    }
  }, [dispatch, fetch]);

  return {
    cities,
    loadingCities,
  };
};
